
import { Component, Mixins, Vue } from 'vue-property-decorator';
import ModelMixin from '@/mixins/ModelMixin';
import LoadableMixin from '@/mixins/LoadableMixin';
import { Action } from 'vuex-class';
import { actions } from '@/store/types';
import { SignupActionType } from '@/types/store/actions';
import { getCurrency } from '@/utils/currency';
import { countriesOptions } from '@/constants/countries';
import { passwordValidationDescription, privacyPolicyURL, termsAndConditionsURL } from '@/constants/constants';
import { mutations } from '@/store/types';
import api from '@/modules/api';
import _get from 'lodash.get';

@Component({
    mixins: [ModelMixin, LoadableMixin],
})
export default class UserSignupModel extends Mixins<LoadableMixin, ModelMixin<boolean>>(
    LoadableMixin,
    ModelMixin,
) {
    @Action(actions.SIGNUP)
    signup!: SignupActionType;
    username = '';
    email = '';
    password = '';
    passwordViewType = 'password';
    checkbox = false;
    protected getCurrency = getCurrency;
    countriesOptions = countriesOptions;
    country: string | undefined = '';
    passwordValidationDescription = passwordValidationDescription;
    privacyPolicyURL = privacyPolicyURL;
    termsAndConditionsURL = termsAndConditionsURL;

    async handleSignup(e: Event) {
        e.preventDefault();

        if (!this.country) return Vue.toasted.error('Country is required');
        if (!this.checkbox)
            return Vue.toasted.error('Please agree to Terms of Service and Privacy Policy before continue');

        this.$store.commit(mutations.LOADING, { loading: true });
        try {
            const response = await api.k9Register(this.username, this.email, this.country ?? '', this.getCurrency(this.country ?? ''));
            this.model = false;
            Vue.toasted.success(response.message);
        } catch (error) {
            const message = _get(error, 'response.data.message');
            if (message) {
                Vue.toasted.error(message);
            }
        } finally {
            this.$store.commit(mutations.LOADING, { loading: false });
        }
    }
    redirectTo(url: string) {
        window.open(url, '_blank');
    }
}
